import { useReduxState } from 'hooks';
import api from 'api';
import { ConfirmButton } from 'components/common';

interface Props {
  achievementId: number;
  buttonText: string;
  confirmTitle: string;
  confirmText: string;
  itemId?: number;
  successMessage: string;
  updateTemplate: () => Promise<void>;
}

const AchievementTemplateDeleteItems = ({
  achievementId,
  buttonText,
  confirmTitle,
  confirmText,
  itemId,
  successMessage,
  updateTemplate
}: Props) => {
  const { messages } = useReduxState();

  const handleDelete = async () => {
    try {
      await api.delete(
        `/admin/achievements/${achievementId}/template${
          itemId ? `/${itemId}` : ''
        }`
      );
      await updateTemplate();

      return true;
    } catch (err) {}
  };

  return (
    <ConfirmButton
      actionText={messages.commonDelete}
      buttonIcon="trash-alt"
      buttonIsDropdown={true}
      buttonText={buttonText}
      category="danger"
      confirmText={confirmText}
      confirmTitle={confirmTitle}
      onConfirm={handleDelete}
      successMessage={successMessage}
    />
  );
};

export default AchievementTemplateDeleteItems;
